import { render } from "./product-addon-clip.vue?vue&type=template&id=42b62e3e&lang=pug"
import script from "./product-addon-clip.vue?vue&type=script&lang=js"
export * from "./product-addon-clip.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__